import { z } from 'zod';
import type { TableEditItem } from '@/components/table/table-edit/types';
import type { PartialUndefinedOrNull } from '@/types/partial';
import { ClienteFiscalPerfil } from '@/features/cliente/types/enum';
import { DestinoNotaFiscal } from '@/features/fiscal/enum/DestinoNotaFiscal';
import { DevolucaoOperacao } from '@/features/fiscal/enum/DevolucaoOperacao';
import { TipoCliente } from '@/features/fiscal/enum/TipoCliente';
import { TributacaoTipo } from '@/features/fiscal/enum/TributacaoTipo';
import { NotaFiscalTipo } from '@/features/nfe/types/enum';

export const RegraFiscalCofinsSchema = z.object({
    rco_cofins_descontar_icms: z.enum(['S', 'N', '']).transform((v) => (v === '' ? 'N' : v)),
    rco_cofins_percentual: z.number().nullable(),
    rco_cofins_valor: z.number().nullable(),
    rco_cofinsst_descontar_icmsst: z.enum(['S', 'N', '']).transform((v) => (v === '' ? 'N' : v)),
    rco_cofinsst_percentual: z.number().nullable(),
    rco_cofinsst_valor: z.number().nullable(),
    rco_cst_cofins: z.string().nullable(),
    rco_destino: z.enum(DestinoNotaFiscal).nullable(),
    rco_devolucao_operacao: z.enum(DevolucaoOperacao).nullable(),
    rco_empresa_idpk: z.number(),
    rco_estado_especifico: z.string().nullable(),
    rco_idpk: z.number(),
    rco_motivo: z.number().nullable(),
    rco_perfil_cliente: z.enum(ClienteFiscalPerfil),
    rco_regra_fiscal_idpk: z.number(),
    rco_tipo: z.enum(NotaFiscalTipo).nullable(),
    rco_tipo_cliente: z.enum(TipoCliente).nullable(),
    rco_tipo_tributacao: z.enum(TributacaoTipo).nullable(),
    rco_tipo_tributacao_st: z.number().nullable(),
    rco_todos_estados: z
        .enum(['S', 'N', ''])
        .nullable()
        .transform((v) => (v === '' ? null : v)),
});

type RegraFiscalCofins = z.infer<typeof RegraFiscalCofinsSchema>;

export type RegraFiscalCofinsBody = PartialUndefinedOrNull<RegraFiscalCofins> & TableEditItem;
